import { NgModule } from '@angular/core';
import { QRCodeComponent } from 'angularx-qrcode';

/**
 * Wrapper module for angularx-qrcode v19+ which exports QRCodeComponent as standalone.
 * Use this in NgModule-based apps: import QRCodeWrapperModule instead of QRCodeModule.
 */
@NgModule({
  imports: [QRCodeComponent],
  exports: [QRCodeComponent]
})
export class QRCodeWrapperModule {}
